module.exports = __webpack_public_path__ + "static/media/glanum_brunnen_tn.985bddb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_brunnen_tn.jpg
// module id = 714
// module chunks = 0